import { LabelWithHelp } from "@components/common/label-with-help";
import {
  Autocomplete,
  AutoCompleteHelperText,
  AutoCompleteOption,
  AutoCompleteSelectedOption,
} from "@flat-ui";
import { TEAM_DISPLAY_NAME } from "@src/constants/team-constants";

interface Props {
  label?: string;
  labelHelp?: string;
  isRequired?: boolean;

  hasAutoFocus?: boolean;

  options: AutoCompleteOption[];
  selectedOptions: AutoCompleteSelectedOption[];
  isValid: (value: string) => boolean;
  helperText?: AutoCompleteHelperText;
  /** Updates the selected options. */
  handleMemberSelect(options: AutoCompleteSelectedOption[]): void;

  /** Validates the typed text (invalid email / already a member). */
  onInputChange(value: string): void;

  placeHolder?: string;
}

/**
 * Renders autocomplete component of flat-ui for members selection. It can be used to select multiple members or emails.
 */
export function MembersAutocomplete({
  label,
  isValid,
  options,
  helperText,
  isRequired,
  hasAutoFocus,
  onInputChange,
  selectedOptions,
  handleMemberSelect,
  placeHolder = `Select ${TEAM_DISPLAY_NAME} or Enter email addresses (Separated by comma, semicolon, or space)`,
  labelHelp = "To add multiple members/emails, simply separate them by pressing enter, semicolon, or comma.",
}: Props): JSX.Element {
  return (
    <>
      {label && (
        <LabelWithHelp isRequired={isRequired} title={label} help={labelHelp} />
      )}

      <Autocomplete
        allowDuplicateOnPaste
        isValid={isValid}
        options={options}
        hasAutoFocus={hasAutoFocus}
        selectedOptions={selectedOptions}
        autocompleteHelperText={helperText}
        handleChange={handleMemberSelect}
        onInputChange={onInputChange}
        placeHolder={placeHolder}
      />
    </>
  );
}
